import React from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils';
import { Theme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { capitalizeFirstLetter } from 'formatters';
import { AccessTime, Link } from '@mui/icons-material';
import { green, lightBlue } from '@mui/material/colors';
import { ApplicationType } from '@trnsact/trnsact-shared-types';
import { IconButton, Stack, Typography, Box, Tooltip } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { DealPipelineListItem } from '../types';

interface Props {
  deal: DealPipelineListItem;
}

export const Card = ({ deal: { deal } }: Props) => {
  const classes = useStyles();

  const history = useHistory();

  const handleRedirectToVODetails = () => {
    history.push(`/vo/${deal.id}`);
  };

  return (
    <Box className={classes.card}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap="0.5rem">
          <Tooltip title="View details">
            <IconButton size="small" color="primary" className="icon-btn-bordered" onClick={handleRedirectToVODetails}>
              <Link />
            </IconButton>
          </Tooltip>

          <Box className={classes.paymentTypeContainer}>
            <Typography variant="body2">{capitalizeFirstLetter(deal.paymentType)}</Typography>
          </Box>
        </Stack>

        {deal.modifiedDateTime && (
          <Stack direction="row" alignItems="center" gap="0.25rem">
            <AccessTime color="disabled" />
            <Typography color="textSecondary">{moment(deal.modifiedDateTime).fromNow(true)}</Typography>
          </Stack>
        )}
      </Stack>

      <Stack>
        <Typography variant="h6" fontWeight={500} component="span">
          {deal.applicationType === ApplicationType.Commercial ? deal.businessName : deal.applicantName}
        </Typography>

        <RenderWithCondition condition={!!deal.applicationType}>
          <Typography color="textSecondary" variant="body2" component="span">
            {capitalizeFirstLetter(deal.applicationType ?? '')}
          </Typography>
        </RenderWithCondition>
      </Stack>

      <Typography variant="h6" fontWeight={500} component="span">
        {formatCurrency(deal.invoiceTotal, true)}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme>({
  card: {
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  paymentTypeContainer: {
    display: 'flex',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.25rem 0.5rem',
    backgroundColor: green[100],
    border: `1px solid ${green[300]}`,
  },
  applicationTypeContainer: {
    display: 'flex',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.25rem 0.5rem',
    backgroundColor: lightBlue[100],
    border: `1px solid ${lightBlue[300]}`,
  },
});
